import { Injectable, inject } from '@angular/core';
import { Bugfender } from '@bugfender/capacitor';
import { CustomerSelectService } from '../customer-select/customer-select.service';
import { environment } from '../../environment';
import { BugfenderFacade } from '@bugfender/common';
import { BUGFENDER } from '../../capacitor-injection-tokens';
import { LocalStorageService } from '../local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class LoggingService {
  private customerSelectService = inject(CustomerSelectService);
  private storageService = inject(LocalStorageService);
  private readonly bugfender = inject<BugfenderFacade>(BUGFENDER);

  private storageKey = 'forceSendOnce';

  public async init(version: string): Promise<void> {
    if (environment.bugfender?.appKey) {
      await Bugfender.init({
        appKey: environment.bugfender.appKey,
        overrideConsoleMethods: true,
        printToConsole: true,
        registerErrorHandler: false,
        // would log every pushState/replaceState URL unredacted, e.g. /oauth2?token=<jwt>.
        // Navigation is logged redacted by the AppComponent instead.
        logBrowserEvents: false,
        logUIEvents: false,
        version: version,
      });
      console.log(`Bugfender initialized with app version ${version} and live version ${environment.version}`);
      if (!(await this.storageService.retrieve(this.storageKey))) {
        this.bugfender.forceSendOnce();
        await this.storageService.store(this.storageKey, true);
      }

      this.customerSelectService.selectCustomer().then(customer => {
        this.bugfender.setDeviceKey('customerId', `${customer.id}`);
        this.bugfender.setDeviceKey('email', `${customer.email}`);
      });
    }
  }
}
